// extracted by mini-css-extract-plugin
export var externalLink = "_ay-0";
export var internalLinkLabel = "_ay-1";